import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/households.png'

const DemographicsHouseholds = dynamic(() => import('src/components/insights/demographics/cards/households'), {
  ssr: false,
})

export const DemographicsHouseholdsWidget: InsightBuilderWidget = {
  id: 'households',
  name: 'Households',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsHouseholds,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
